import { __awaiter } from "tslib";
import * as React from 'react';
import LabSimService, { StateContext } from '../services/LabSimService';
import PageFooter from '../partials/PageFooter';
import { T } from '@testout/labsim-ui-atomics';
import styles from './Settings.module.less';
import { isUrlValid } from '../helpers/UrlHelper';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => React.createElement(Settings, Object.assign({}, props, { context: stateContext })))));
class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.maxUrlLength = 2000;
        this.onHelpUrlChange = (e) => {
            this.setState({ helpUrl: e, urlValidationError: false });
        };
        this.onSave = () => {
            if (this.state.helpUrl.length > this.maxUrlLength) {
                this.setState({ urlLengthError: true });
                return false;
            }
            if (this.state.helpUrl.length > 0 && isUrlValid(this.state.helpUrl) === false) {
                this.setState({ urlValidationError: true });
                return false;
            }
            LabSimService.saveHelpUrl(this.props.context.serverState.schoolGuid, this.state.helpUrl);
            this.props.history.goBack();
            return true;
        };
        this.state = { helpUrl: '', urlLengthError: false, urlValidationError: false };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ dataLoaded: false });
            const res = yield LabSimService.getHelpUrl();
            if (res && res.status === 200 && !!res.data) {
                this.setState({ helpUrl: res.data });
            }
            this.setState({ dataLoaded: true });
        });
    }
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.settings },
                React.createElement(T.Text.H1, { variation: T.Text.Variation.H1_Large, automationId: 'title' }, "Settings"),
                React.createElement(T.InfoBox, { automationId: 'infoBox', className: styles.infoBox },
                    React.createElement(T.InfoBox.Body, { variation: T.InfoBox.Variation.Custom, iconVariation: T.IconVariation.InfoCircle }, "You can provide a custom link for directing or helping or your learners with product activation.")),
                React.createElement(T.Form, { automationId: 'form', onCancel: this.props.history.goBack, onSubmit: this.onSave, className: styles.formBox },
                    React.createElement(T.Form.Field, { automationId: 'url' },
                        React.createElement(T.Form.Label, null, "Activation Code Help URL"),
                        React.createElement(T.Form.InputText, { automationId: 'helpUrlInput', value: this.state.helpUrl, onChange: this.onHelpUrlChange, disabled: !this.state.dataLoaded }),
                        React.createElement(T.Text.Span, { className: styles.hint, automationId: 'hint', variation: T.Text.Variation.Small }, "This should be a full length URL beginning with http:// or https://"),
                        this.state.urlLengthError && React.createElement(T.Form.Error, null, "URL is too long"),
                        this.state.urlValidationError && (React.createElement(T.Form.Error, null, "URL is not valid"))),
                    React.createElement(T.Form.ActionBar, { cancelText: 'Cancel' }))),
            React.createElement("div", null,
                React.createElement(PageFooter, null))));
    }
}
//# sourceMappingURL=Settings.js.map